import { Button, type ButtonProps, Text, useToast } from "@chakra-ui/react";
import { copyToClipboard } from "@krainovsd/js-helpers";
import type React from "react";
import { useTranslation } from "react-i18next";
import { CopyIcon } from "@/components/icons";

interface CopyButtonProps extends ButtonProps {
  label: string;
  alertText?: string;
  showAlert?: boolean;
  showLabel?: boolean;
  bold?: boolean; // bold text
  copyIcon?: boolean;
  textOpacity?: string;
  textWidth?: string;
  textSize?: string;
  textClass?: string;
}

export function CopyButton(props: CopyButtonProps) {
  const {
    label,
    alertText,
    showAlert,
    showLabel = true,
    size = "sm",
    variant = "ghost",
    bold = false,
    copyIcon = true,
    colorScheme = "gray",
    textOpacity,
    textWidth,
    textSize,
    textClass,
    ...otherProps
  } = props;

  const { t } = useTranslation();
  const toast = useToast();
  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    void copyToClipboard(label.toString());
    if (showAlert) {
      toast({
        title: alertText ?? t("common.copied", { defaultValue: "Скопировано!" }),
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    }
  };
  return (
    <Button
      variant={variant}
      size={size}
      colorScheme={colorScheme}
      rightIcon={copyIcon ? <CopyIcon /> : undefined}
      onClick={handleCopy}
      display={"flex"}
      height={"auto"}
      padding={0}
      {...otherProps}
    >
      {showLabel && (
        <Text
          fontSize={textSize}
          textAlign={"left"}
          maxWidth={textWidth ?? "250px"}
          whiteSpace={"normal"}
          variant={bold ? "text_sm_bold" : "text_sm_normal"}
          wordBreak={"break-all"}
          opacity={textOpacity}
          className={textClass}
        >
          {label}
        </Text>
      )}
    </Button>
  );
}
